/* Responsibility: Check to see if feature should be enabled */
import dom from '../lib/modules/dom.js';

export function enableFeature (name) {
    // Fix for 'operation is insecure' error in Firefox
    try {
        window.localStorage; // eslint-disable-line no-unused-expressions
    } catch (error) {
        return;
    }

    return window.localStorage[`feature_${name}`];
}

export function enableFeatureElement (name, element) {
    // Fix for 'operation is insecure' error in Firefox
    try {
        window.localStorage; // eslint-disable-line no-unused-expressions
    } catch (error) {
        return;
    }

    if (window.localStorage[`feature_${name}`]) {
        dom.removeClass('hidden', element);
    }
}



// WEBPACK FOOTER //
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/shared/overlay/src/main/webapp/scripts/featureToggling/featureToggler.js